import { Switch, Route } from "react-router-dom";
import { useIdleTimer } from "react-idle-timer";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Layout from "./Layout";
import DrawerHeader from "../../../components/common/DrawerHeader";
import Dashboard from "./Dashboard";
import NotFoundPage from "../NotFoundPage";
import ViewIndividualRequest from "../../../components/KycForm/ViewIndividualRequestSubmission";
import ViewCorporateRequestSubmission from "../../../components/KycForm/ViewCorporateRequestSubmission";

const AdminRoutes = () => {
	// eslint-disable-next-line no-unused-vars
	const handleOnIdle = (event) => {
		localStorage.clear();
		window.location = "/admin/login";
	};

	useIdleTimer({
		timeout: 1000 * 15 * 60,
		onIdle: handleOnIdle,
		// onActive: handleOnActive,
		// onAction: handleOnAction,
		debounce: 500,
	});
	return (
		<Box>
			<Box
				sx={{
					display: "flex",
					backgroundColor: "#fff",
				}}
			>
				<CssBaseline />
				<Layout />
				<Box
					component="main"
					sx={{
						flexGrow: 1,
						backgroundColor: "#fff",
						minHeight: "100vh",
					}}
				>
					<DrawerHeader />
					<Box>
						<Switch>
							<Route
								exact
								path="/admin/kyc-submission/dashboard"
								component={Dashboard}
							/>
							<Route
								exact
								path="/admin/kyc-submission/view-request/individual/:id"
								component={ViewIndividualRequest}
							/>
							<Route
								exact
								path="/admin/kyc-submission/view-request/corporate/:id"
								component={ViewCorporateRequestSubmission}
							/>
							<Route path="*" component={NotFoundPage} />
						</Switch>
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

export default AdminRoutes;
